import React from 'react';
import request from 'request';
import dayjs from 'dayjs';

import { Button, Paper, Typography } from '@material-ui/core';

import ErrorIcon from '@material-ui/icons/ErrorOutline';
import LinkIcon from '@material-ui/icons/Link';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Header from './Header';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f5f5f5',
      light: '#ffffff',
      dark: '#c2c2c2'
    },
    secondary: {
      main: '#29b6f6',
      light: '#73e8ff',
      dark: '#0086c3'
    },
  },
  typography: {
    useNextVariants: true,
  },
});

class Task extends React.Component {
  state = {
    text: '',
    model: '',
    infoStatus: 'Fetching information',
    audioStatus: 'Checking generation status',
    serverError: false,
    link: ''
  }

  fetchInformation = () => {
    request.post({
      url: `${document.location.protocol}//${document.location.host}/api/get_info`,
      json: true,
      body: {
        'job_id': this.props.match.params.id,
      }},
      (error, response, body) => {
      if (error) {
        this.setState({serverError: true, infoStatus: "Failed to connnect to server"})
        console.log(error)
        return
      }

      if (body['success']) {
        this.setState({
          text: body['text'],
          model: body['model'],
          creationDate: body['creation_date'],
          infoStatus: ''
        })
      } else {
        this.setState({serverError: true, infoStatus: body['error']})
      }
     }
   )
  }

  fetchStatus = () => {
    request.post({
      url: `${document.location.protocol}//${document.location.host}/api/get_status`,
      json: true,
      body: {
        'job_id': this.props.match.params.id,
      }},
      (error, response, body) => {
        if (error) {
          this.setState({serverError: true, audioStatus: "Failed to connnect to server"})
          console.log(error)
          return
        }

        if (body['success'] && body['status'] === 'Done') {
          this.setState({audioStatus: ''})
        } else if (body['success']) {
          this.setState({audioStatus: body['status']})
          setTimeout(this.fetchStatus, 1000)
        } else {
          this.setState({serverError: true, audioStatus: body['error']})
        }
      }
    )
  }

  componentDidMount() {
    this.fetchInformation()
    this.fetchStatus()
  }

  render() {
    let formattedDate = dayjs(this.state.creationDate).format('DD MMM, YYYY HH:mm A')
    let jobBody = (
      <div style={{display: 'flex', flexDirection: 'column', height: '80px', justifyContent: 'center'}}>
        <Typography variant="body1" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
          <ErrorIcon />
          &nbsp;
          {this.state.audioStatus}
        </Typography>
      </div>
    )

    if (!this.state.serverError) {
      jobBody = (
        <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
          <div style={{display: 'flex', flexDirection: 'row', flexGrow: '0'}}>
            <Typography variant="button"> Model: </Typography>
            &nbsp; &nbsp;
            <Typography variant="body1"> {this.state.infoStatus || this.state.model} </Typography>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', flexGrow: '1'}}>
            <Typography variant="button"> Text: </Typography>
            &nbsp; &nbsp;
            <Typography variant="body1" paragraph  style={{textAlign: 'left'}}> {this.state.infoStatus || this.state.text} </Typography>
          </div>
          {this.state.audioStatus}
          {this.state.audioStatus.length === 0 && <audio controls preload="none" style={{width: '100%'}} src={`${document.location.protocol}//${document.location.host}/api/audio/${this.props.match.params.id}.wav`}></audio>}
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Typography variant="caption" style={{flexGrow: '1', textAlign: 'left'}}> {this.state.infoStatus || formattedDate} </Typography>
            <Button style={{fontSize: '0.75rem'}} onClick={this.handleCopyLink}> <LinkIcon /> &nbsp; Share </Button>
          </div>
          {this.state.link.length !== 0 &&
            <Paper>
              <Typography variant="overline"> <a href={this.state.link}>{this.state.link}</a> </Typography>
            </Paper>
          }
        </div>
      )
    }

    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <Header />
          <div className="Content">
            <Paper style={{
              backgroundColor: "rgb(227, 236, 251)",
              minHeight: '80px',
              marginTop: '40px',
              padding: '10px'
              }}>
              {jobBody}
            </Paper>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Task;
